import { z } from 'zod';

export const dsl_parse_failed = z.object({
  error_class: z.enum(['lex', 'parse', 'reference', 'validation']),
  context: z.enum(['wizard', 'builder', 'import', 'load']),
}).strict();

export const migration_applied = z.object({
  kind: z.enum(['pattern', 'session', 'state', 'settings']),
  from_version: z.number().int().nonnegative(),
  to_version: z.number().int().positive(),
}).strict();

export const unknown_item_preserved = z.object({
  kind: z.enum(['pattern', 'session']),
  count: z.number().int().positive(),
}).strict();

export const storage_quota_warning = z.object({}).strict();
